export function isVisibleAssetDocument(document) {
  return ![document.file?.object_key, document.file?.file_name, document.file?.filename]
    .some((value) => String(value || '').toLowerCase().endsWith('.metadata.json'));
}
